import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Building2, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { apiError } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

export default function Abteilungen() {
  const [rows, setRows] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [name, setName] = useState("");

  const load = async () => {
    const [d, e] = await Promise.all([api.get("/departments"), api.get("/employees")]);
    setRows(d.data || []);
    setEmployees(e.data || []);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return toast.error("Name erforderlich");
    try {
      await api.post("/departments", { name: name.trim() });
      toast.success("Abteilung angelegt");
      setName("");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const del = async (id) => {
    try { await api.delete(`/departments/${id}`); toast.success("Abteilung gelöscht"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const countIn = (id) => employees.filter((u) => (u.department_ids || []).includes(id)).length;

  return (
    <div>
      <PageHeader title="Abteilungen" subtitle="Lege Abteilungen an (z. B. Küche, Service, Reinigung). Mitarbeiter ordnest du im Mitarbeiter-Dialog zu." testid="abteilungen-header" />
      <div className="max-w-2xl grid gap-5">
        <Card className="p-6 border-slate-200 rounded-xl space-y-4">
          <h3 className="font-semibold text-slate-900">Neue Abteilung</h3>
          <div className="flex gap-2">
            <Input data-testid="dept-name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="z. B. Küche" />
            <Button onClick={add} data-testid="dept-add" className="brand-bg text-white hover:opacity-90 shrink-0"><Plus className="h-4 w-4 mr-2" /> Anlegen</Button>
          </div>
        </Card>

        <Card className="border-slate-200 rounded-xl overflow-hidden">
          {rows.length === 0 ? (
            <EmptyState icon={Building2} title="Noch keine Abteilungen" testid="dept-empty" />
          ) : (
            <div className="divide-y divide-slate-100">
              {rows.map((d) => (
                <div key={d.id} className="flex items-center justify-between gap-3 p-4" data-testid={`dept-row-${d.id}`}>
                  <div className="flex items-center gap-3">
                    <div className="h-9 w-9 rounded-lg brand-bg text-white flex items-center justify-center"><Building2 className="h-4 w-4" /></div>
                    <div>
                      <div className="font-medium text-slate-900">{d.name}</div>
                      <Badge variant="outline" className="bg-slate-50 text-xs mt-0.5">{countIn(d.id)} Mitarbeiter</Badge>
                    </div>
                  </div>
                  <button onClick={() => del(d.id)} data-testid={`dept-delete-${d.id}`} className="text-slate-300 hover:text-rose-500"><Trash2 className="h-4 w-4" /></button>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
